'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNoEncryption = function MdNoEncryption(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.8 10v2l-3-3c0.5-4.2 3.9-7.4 8.2-7.4 4.6 0 8.4 3.8 8.4 8.4v3.4h1.6c1.8 0 3.4 1.4 3.4 3.2v14l-17.3-17.2h9.1v-3.4c0-2.8-2.4-5.2-5.2-5.2s-5.2 2.4-5.2 5.2z m20.2 26.3l-2 2.1-1.9-1.9c-0.3 0.1-0.7 0.1-1.1 0.1h-20c-1.8 0-3.4-1.4-3.4-3.2v-16.8c0-1.2 0.8-2.3 1.8-2.8l-3.4-3.4 2-2z' })
        )
    );
};

exports.default = MdNoEncryption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/no-encryption.js
// module id = 994
// module chunks = 0